<template>
  <section data-module="hcAbout1">
    <div class="intro">
      <h1 class="h1">
        We are an interdisciplinary team of researchers, designers, builders and doers. 
      </h1>
      <p>
        We are powered by empathy, curiosity, and collaboration. Drawing on our vast global experience in sectors including technology, health, transportation, education, and much more, we make ideas relevant, memorable, and come to life. 
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'module_hcAboutIntro',
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

[data-module="hcAbout1"] {
  @include spacer($top: true);
  @include grid($subgrid: true);
  @include spacer();

  @include mq($bp--tablet, up) {
    min-height: 80vh;
    align-items: center;
  }

  .intro {
    grid-column: 1 / -1;
  }
}

</style>



// WEBPACK FOOTER //
// src/modules/hcAboutIntro.vue